/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RiskScore
 */
export interface RiskScore {
}

/**
 * Check if a given object implements the RiskScore interface.
 */
export function instanceOfRiskScore(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RiskScoreFromJSON(json: any): RiskScore {
    return RiskScoreFromJSONTyped(json, false);
}

export function RiskScoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskScore {
    return json;
}

export function RiskScoreToJSON(value?: RiskScore | null): any {
    return value;
}

